import { createRoot } from 'react-dom/client'

import * as Sentry from '@sentry/react'

import App from 'app/application/presentation/App'
import { config } from 'app/config'

import './main.scss'

Sentry.init({
  dsn: config.sentryDsn,
  enabled: import.meta.env.MODE === 'production',
})

createRoot(document.getElementById('root')!).render(<App />)
